/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import PropTypes from 'prop-types';

import { FileInput } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

import ImagePreview from './ImagePreview';

const styles = (theme) => ({
  root: {
    position: 'relative',
    minHeight: '200px',
  },
  preview: {
    position: 'aboslute',
  },
  dropZone: {
    position: 'absolute',
    background: 'none',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    '& div': {
      color: 'white',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.4)',
      padding: '30px 60px',
    },
  },
});

class PreviewFileInput extends React.Component {
  render() {
    const { classes, placeholder, source } = this.props;

    return (
      <FileInput
        source={source}
        label="Background image"
        placeholder={placeholder}
        classes={classes}
      >
        <ImagePreview source={source} />
      </FileInput>
    );
  }
}

PreviewFileInput.propTypes = {
  placeholder: PropTypes.object.isRequired,
};

export default withStyles(styles)(PreviewFileInput);
